/* RK collection (PLP): keep --rk-header-h in sync with the live header bottom so the
   cover-on-scroll hero pin and the sticky FILTERS bar sit right below the sticky header.
   Same header-resolution approach as rk-mega.js. Filter/sort open-close is handled by
   Dawn's <menu-drawer> (drawer-mode facets), so no extra JS is needed for that. */
(function () {
  function headerEl() {
    return (
      document.querySelector('.header-wrapper') ||
      document.querySelector('.section-header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('.header')
    );
  }
  var lastHeaderH = null;
  function setVar() {
    var h = headerEl();
    var bottom = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 110;
    // Only write the var when it actually changes. The sticky header keeps a constant
    // height while scrolling, so this turns the per-scroll listener into a cheap no-op
    // and stops it invalidating styles (and nudging the fixed hero's top) every frame.
    if (bottom !== lastHeaderH) {
      lastHeaderH = bottom;
      document.documentElement.style.setProperty('--rk-header-h', bottom + 'px');
    }
  }
  /* Hero parallax glide - measured from graff.com: the hero TEXT stays fixed while the
     image drifts upward at ~5.3% of scroll (8px per 150px). Replicated exactly here.
     Disabled when the user prefers reduced motion. */
  var RATIO = 0.053;
  var MAX_SHIFT = 50; /* px; the rising grid always covers the pin's bottom edge before this drift could reveal a gap */
  var heroImgs = [];
  var ticking = false;
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function applyParallax() {
    ticking = false;
    if (!heroImgs.length) return;
    var shift = Math.min(MAX_SHIFT, Math.max(0, window.scrollY * RATIO));
    for (var i = 0; i < heroImgs.length; i++) {
      heroImgs[i].style.transform = 'translate3d(0, ' + (-shift) + 'px, 0)';
    }
  }
  function onScrollParallax() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(applyParallax);
    }
  }
  function initParallax() {
    // Drive every hero layer (desktop banner + optional phone image + placeholder),
    // so the glide works whichever is visible at the current breakpoint.
    heroImgs = Array.prototype.slice.call(document.querySelectorAll('.rk-chero__img, .rk-chero__ph'));
    if (!heroImgs.length || reduceMotion()) return;
    window.addEventListener('scroll', onScrollParallax, { passive: true });
    applyParallax();
  }

  /* Graff-style slide-in filter panel: open/close the 542px panel + scrim. */
  function initFilters() {
    var panel = document.querySelector('[data-rk-filters]');
    if (!panel) return;
    var scrim = document.querySelector('[data-rk-filters-scrim]');
    var openBtn = document.querySelector('[data-rk-filters-open]');
    var closeBtn = document.querySelector('[data-rk-filters-close]');
    function open() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('is-open');
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
      document.body.style.overflow = '';
    }
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
  }

  /* REAL filtering. One composer builds the target URL from the panel's state
     and navigates (server-side results, correct pagination + counts):
       - tags (Metal / Gemstones)  -> Shopify tag path  /collections/x/tag-a+tag-b (AND)
       - price                     -> native storefront filter.v.price.gte / .lte
       - sort                      -> sort_by param
     Category rows are plain collection links and need no JS. */
  function initFilterState() {
    var root = document.querySelector('[data-rk-filter-root]');
    if (!root) return;
    var baseUrl = root.getAttribute('data-base-url') || location.pathname.split('/').slice(0, 3).join('/');
    var sort = root.getAttribute('data-sort') || '';
    var price = root.querySelector('[data-rk-price]');
    var lo = price && price.querySelector('[data-rk-price-lo]');
    var hi = price && price.querySelector('[data-rk-price-hi]');
    var fill = price && price.querySelector('[data-rk-price-fill]');
    var loLabel = price && price.querySelector('[data-rk-price-lo-label]');
    var hiLabel = price && price.querySelector('[data-rk-price-hi-label]');
    var ceil = price ? parseFloat(price.getAttribute('data-ceil')) || 100000 : 0;
    var floor = price ? parseFloat(price.getAttribute('data-floor')) || 0 : 0;

    function money(n) { return window.RK && window.RK.formatMoney ? window.RK.formatMoney(n) : '$' + Math.round(n).toLocaleString(); }
    function bounds() {
      var a = parseFloat(lo.value);
      var b = parseFloat(hi.value);
      if (a > b) { var t = a; a = b; b = t; }
      return [a, b];
    }
    function paint() {
      if (!price) return;
      var ab = bounds();
      var range = ceil - floor || 1;
      var p1 = ((ab[0] - floor) / range) * 100;
      var p2 = ((ab[1] - floor) / range) * 100;
      if (fill) { fill.style.insetInlineStart = p1 + '%'; fill.style.inlineSize = (p2 - p1) + '%'; }
      if (loLabel) loLabel.textContent = money(ab[0]);
      if (hiLabel) hiLabel.textContent = money(ab[1]);
    }
    function compose() {
      var tags = Array.prototype.slice
        .call(root.querySelectorAll('[data-rk-tag]:checked'))
        .map(function (el) { return el.getAttribute('data-rk-tag'); });
      var url = baseUrl + (tags.length ? '/' + tags.join('+') : '');
      var params = [];
      if (sort) params.push('sort_by=' + encodeURIComponent(sort));
      if (price) {
        var ab = bounds();
        if (ab[0] > floor) params.push('filter.v.price.gte=' + ab[0]);
        if (ab[1] < ceil) params.push('filter.v.price.lte=' + ab[1]);
      }
      return url + (params.length ? '?' + params.join('&') : '');
    }
    function go() { window.location.assign(compose()); }

    /* Phones BATCH their selections behind an Apply button instead of navigating on
       every tap. Choosing two facets used to cost two full page loads on mobile data,
       and each one closed the panel and lost its scroll position. Desktop keeps the
       instant apply it was signed off with. */
    var batch = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var applyBar = document.querySelector('[data-rk-filters-applybar]');
    var applyBtn = document.querySelector('[data-rk-filters-apply]');

    function markSort(btn) {
      root.querySelectorAll('[data-rk-sort]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
    }

    if (batch && applyBar) applyBar.hidden = false;

    root.querySelectorAll('[data-rk-tag]').forEach(function (box) {
      box.addEventListener('change', function () { if (!batch) go(); });
    });
    root.querySelectorAll('[data-rk-sort]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sort = btn.getAttribute('data-rk-sort');
        if (batch) markSort(btn);
        else go();
      });
    });
    if (lo && hi) {
      lo.addEventListener('input', paint);
      hi.addEventListener('input', paint);
      lo.addEventListener('change', function () { if (!batch) go(); });
      hi.addEventListener('change', function () { if (!batch) go(); });
      paint();
    }
    if (applyBtn) applyBtn.addEventListener('click', go);
  }

  /* Graff PLP card carousel: chevron arrows (shown on card hover via CSS) slide the
     product's photos horizontally, 0.3s ease. Arrows are spans inside the card link,
     so clicks must not navigate. RTL flips the translate direction. */
  function initCardCarousels() {
    document.querySelectorAll('[data-rk-card-slides]').forEach(function (media) {
      var slides = media.querySelector('.rk-card__slides');
      if (!slides || slides.children.length < 2) return;
      var count = slides.children.length;
      var index = 0;
      var sign = document.documentElement.dir === 'rtl' ? 1 : -1;
      function go(n) {
        index = (n + count) % count;
        slides.style.transform = 'translateX(' + sign * index * 100 + '%)';
      }
      function bind(sel, step) {
        var btn = media.querySelector(sel);
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          go(index + step);
        });
      }
      bind('[data-rk-card-prev]', -1);
      bind('[data-rk-card-next]', 1);
    });
  }


  /* Pages of the collection grid. The section renders the WHOLE collection,
     priced pieces first and enquire-only pieces last (Liquid can only reorder
     inside one paginate page), and this splits it into pages of data-per using
     ?pg=N. Same markup and classes as Dawn's snippets/pagination.liquid. With
     no JS every piece simply shows on one page. */
  function initPager() {
    var pager = document.querySelector('[data-rk-pager]');
    var grid = document.getElementById('product-grid');
    if (!pager || !grid || pager.dataset.rkReady) return;
    pager.dataset.rkReady = '1';
    var items = grid.querySelectorAll(':scope > .rk-grid__item');
    var per = parseInt(pager.getAttribute('data-per'), 10) || 24;
    var pages = Math.ceil(items.length / per);
    if (pages < 2) return;
    var params = new URLSearchParams(location.search);
    var cur = Math.min(Math.max(parseInt(params.get('pg'), 10) || 1, 1), pages);
    items.forEach(function (li, i) { li.hidden = i < (cur - 1) * per || i >= cur * per; });

    function href(n) {
      var q = new URLSearchParams(location.search);
      if (n === 1) q.delete('pg'); else q.set('pg', n);
      var s = q.toString();
      return location.pathname + (s ? '?' + s : '');
    }
    var caretTpl = pager.querySelector('[data-rk-caret]');
    function caret() {
      var w = document.createElement('span');
      w.className = 'svg-wrapper';
      if (caretTpl) w.appendChild(caretTpl.content.cloneNode(true));
      return w;
    }
    function li(child) { var l = document.createElement('li'); l.appendChild(child); return l; }
    function link(n, cls, label, content) {
      var a = document.createElement('a');
      a.href = href(n);
      a.className = cls;
      a.setAttribute('aria-label', label);
      if (typeof content === 'string') a.textContent = content; else a.appendChild(content);
      return a;
    }
    var pageLabel = function (n) { return (pager.getAttribute('data-page-label') || 'Page %n').replace('%n', n); };
    var nav = document.createElement('nav');
    nav.className = 'pagination';
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', pager.getAttribute('data-label') || 'Pagination');
    var ul = document.createElement('ul');
    ul.className = 'pagination__list list-unstyled';
    ul.setAttribute('role', 'list');
    if (cur > 1) ul.appendChild(li(link(cur - 1, 'pagination__item pagination__item--next pagination__item-arrow link motion-reduce', pager.getAttribute('data-prev') || 'Previous page', caret())));
    for (var n = 1; n <= pages; n++) {
      if (n === cur) {
        var a = document.createElement('a');
        a.setAttribute('role', 'link');
        a.setAttribute('aria-disabled', 'true');
        a.setAttribute('aria-current', 'page');
        a.setAttribute('aria-label', pageLabel(n));
        a.className = 'pagination__item pagination__item--current light';
        a.textContent = n;
        ul.appendChild(li(a));
      } else {
        ul.appendChild(li(link(n, 'pagination__item link', pageLabel(n), String(n))));
      }
    }
    if (cur < pages) ul.appendChild(li(link(cur + 1, 'pagination__item pagination__item--prev pagination__item-arrow link motion-reduce', pager.getAttribute('data-next') || 'Next page', caret())));
    nav.appendChild(ul);
    pager.appendChild(nav);
    pager.setAttribute('data-page', cur);
    pager.hidden = false;
  }

  function init() {
    setVar();
    window.addEventListener('resize', setVar, { passive: true });
    window.addEventListener('scroll', setVar, { passive: true });
    window.addEventListener('load', setVar);
    document.addEventListener('shopify:section:load', setVar);
    initParallax();
    initFilters();
    initFilterState();
    initCardCarousels();
    initPager();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
